import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
    lastfetch: null,
    status: "idle"
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        storeUser: (state, action) => {
            state.user = { ...action.payload };
            state.status = 'success';
        },
        updateUser: (state, action) => {
            const { field, value } = action.payload;
            state.user[field] = value;
        },
        removeUser: state => {
            state.user = {}
            state.status = 'idle';
        },
    },
});

export const { storeUser, updateUser, removeUser } = userSlice.actions;
export default userSlice.reducer;